/**
 * CORE-2113 — повтор запроса, на который шлюз ответил 502/503/504.
 *
 * Такой ответ отдаёт nginx-proxy, а не бэкенд: в окно выкатки у него нет
 * живого контейнера API (GlitchTip #176 — вход в нативном приложении 504 во
 * время прод-деплоя 05.11). Запрос до приложения не дошёл, поэтому повтор
 * через секунду-две обычно уже попадает в новый контейнер.
 *
 * Повторяем только то, что повторять безопасно: GET/HEAD и вход (повторный
 * вход ничего не создаёт). POST/PUT/PATCH/DELETE не трогаем — правило
 * CORE-1905. На вебе GET на шлюзовой 5xx уже уходит на RU-эдж
 * (apiFallback, CORE-604), здесь он и не нужен — вызывающий решает сам.
 */
export const GATEWAY_STATUSES: ReadonlySet<number> = new Set([502, 503, 504]);
export const GATEWAY_RETRY_DELAYS_MS: readonly number[] = [1000, 2500];

export async function retryOnGateway(
  send: () => Promise<Response>,
  delaysMs: readonly number[] = GATEWAY_RETRY_DELAYS_MS,
  sleep: (ms: number) => Promise<void> = (ms) => new Promise((r) => setTimeout(r, ms)),
): Promise<Response> {
  let response = await send();
  for (const delay of delaysMs) {
    if (!GATEWAY_STATUSES.has(response.status)) return response;
    await sleep(delay);
    response = await send();
  }
  return response;
}
